import type { CustomFieldDef } from '../../lib/outreach/types'
import type { SavedView } from '../../lib/outreach/savedViews'
import type { ContactsFilters } from './useContacts'

/**
 * Saved views are stored in the `saved_views` user setting (shared with the
 * legacy page, which ignores the extra `customField` property). These two
 * functions convert between a stored view and the contacts list filters.
 */

export function filtersToView(name: string, f: ContactsFilters): SavedView {
  const view: SavedView = {
    name: name.trim(),
    search: f.search,
    stage: f.stage,
    country: f.country,
    location: f.location,
    phonePrefix: f.phonePrefix,
    scoreMin: f.scoreMin,
    scoreMax: f.scoreMax,
    tagFilter: f.tagFilter,
  }
  if (f.customKey && f.customValue.trim()) {
    view.customField = { key: f.customKey, value: f.customValue.trim() }
  }
  return view
}

export function viewToFilters(
  view: SavedView,
  base: ContactsFilters,
  defs: readonly CustomFieldDef[],
): ContactsFilters {
  const def = view.customField ? defs.find((d) => d.key === view.customField?.key) : undefined
  return {
    ...base,
    search: view.search,
    stage: view.stage,
    country: view.country,
    location: view.location,
    phonePrefix: view.phonePrefix,
    scoreMin: view.scoreMin,
    scoreMax: view.scoreMax,
    tagFilter: view.tagFilter,
    customKey: def ? def.key : '',
    customType: def ? def.type : '',
    customValue: def && view.customField ? view.customField.value : '',
  }
}
